import { createStore, createLogger } from 'vuex';
import modules from './modules';

const debug = process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'testing';

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules,
  strict: debug,
  plugins: debug ? [createLogger()] : []
});
